import { createComponent } from '@carvana/merch-components';

export const VehicleTileContainer = createComponent('div', {
  className: 'flex min-h-6xl items-center gap-lg self-stretch'
});

export const VehicleImageContainer = createComponent('div', {
  className:
    'relative h-6xl w-[70px] shrink-0 overflow-hidden rounded-md bg-background-weak'
});

export const VehicleDetailsContainer = createComponent('div', {
  className: 'flex w-full flex-col gap-sm overflow-visible'
});

export const VehicleName = createComponent('p', {
  className: 'text-text-strong'
});

export const VehiclePrice = createComponent('p', {
  className: 'text-text-strong t-heading-md'
});
